/* CN Pair Popup — matching-pair cross-sell (sleeve ⇄ wristband).
   Rendered inert by snippets/cn-pair-popup.liquid on the two PDPs only; the
   ATC success handler in side-cart.js calls window.CNPairPopup.maybeShow(...)
   between /cart/add.js success and opening the side cart. Every path out of
   here — including any error — calls continueFn so the side cart always opens.
   Enable via theme setting, Intelligems variant JS (window.CN_PAIR_POPUP=true),
   or QA override ?cn-pair-popup=1 (sessionStorage-persisted; =0 clears). */
(function () {
  "use strict";

  var cfgEl = document.getElementById("cn-pair-popup-data");
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent || "{}"); } catch (e) { return; }
  if (!cfg || !cfg.ownHandle || !cfg.oppositeHandle) return;

  // Same scope as the ladder's Shopify automatic discounts — see
  // scripts/sync-offer-discounts.mjs LEVER_HANDLES. Addon products
  // (decal-sheet-add-on, coach-sleeve-add-on) are excluded implicitly.
  var LEVER_HANDLES = [
    "custom-numbered-compression-arm-sleeve",
    "custom-numbered-beanie",
    "custom-wristband",
    "custom-numbered-varsity-jacket"
  ];

  var QA_KEY = "cn-pair-popup";
  var SHOWN_KEY = "cn-pair-popup-shown:" + cfg.direction;
  var DECIDE_MS = 1200; // max time the popup may delay the side cart

  function qlog(msg) {
    try { console.info("[cn-pair-popup] " + msg); } catch (e) {}
  }

  // Complementary band colors for sleeve colors the wristband doesn't carry
  // (Mike-curated 2026-07-28, not strictly nearest-match) plus the Light/Ice
  // Blue naming split — precedent in side-cart.js jacket logic.
  var COLOR_FALLBACK = {
    "Pink": "Hot Pink",
    "Gold": "Yellow",
    "Teal": "Hot Pink",
    "Mint": "Ice Blue",
    "Elephant Grey": "Grey",
    "Elephant Ice Blue": "Ice Blue",
    "Elephant Red": "Red",
    "Elephant Royal": "Royal",
    "Elephant White": "White",
    "Maroon": "White",
    "Galaxy": "Ice Blue",
    "Fire": "Orange",
    "Light Blue": "Ice Blue",
    "Ice Blue": "Light Blue"
  };

  // CSS colors for the number preview + swatch dots (names that aren't valid
  // CSS colors, or whose CSS value reads wrong on white).
  var CSS_COLOR = {
    "Royal": "rgb(0, 0, 204)",
    "Light Blue": "rgb(51, 204, 255)",
    "Ice Blue": "rgb(51, 204, 255)",
    "Neon Green": "rgb(2, 249, 54)",
    "Navy": "rgb(0, 5, 116)",
    "Hot Pink": "rgb(246, 33, 87)",
    "Orange": "rgb(255, 64, 0)",
    "Pink Sprinkles": "rgb(255, 158, 195)",
    "Blue Sprinkles": "rgb(140, 205, 255)",
    "Grey": "rgb(150, 150, 150)",
    "White": "#ffffff",
    "No Color": "transparent"
  };
  function cssColor(name) { return CSS_COLOR[name] || name || "transparent"; }

  // ── QA override: ?cn-pair-popup=1 arms the session, =0 disarms.
  // QA mode is deterministic: it re-arms the shown-once keys on every visit
  // and bypasses the suppression rules, so every ATC shows the popup. ──
  try {
    var qa = location.search.match(/[?&]cn-pair-popup=([01])/);
    if (qa) {
      if (qa[1] === "1") {
        sessionStorage.setItem(QA_KEY, "1");
        sessionStorage.removeItem("cn-pair-popup-shown:sleeve-to-wristband");
        sessionStorage.removeItem("cn-pair-popup-shown:wristband-to-sleeve");
        qlog("QA mode ON — popup shows on every ATC (suppression rules bypassed)");
      } else {
        sessionStorage.removeItem(QA_KEY);
        sessionStorage.removeItem("cn-pair-popup-shown:sleeve-to-wristband");
        sessionStorage.removeItem("cn-pair-popup-shown:wristband-to-sleeve");
        qlog("QA mode OFF");
      }
    }
  } catch (e) { /* sessionStorage unavailable — overrides just won't persist */ }

  function qaMode() {
    try { return sessionStorage.getItem(QA_KEY) === "1"; } catch (e) { return false; }
  }
  function enabled() {
    return cfg.enabled === true || window.CN_PAIR_POPUP === true || qaMode();
  }

  // ── Data fetches ──
  var productPromise = null;
  function fetchOpposite() {
    if (!productPromise) {
      productPromise = fetch("/products/" + cfg.oppositeHandle + ".js", {
        headers: { Accept: "application/json" }
      }).then(function (r) {
        if (!r.ok) throw new Error("cn-pair-popup: product fetch " + r.status);
        return r.json();
      });
      // A failed prefetch must not poison later attempts.
      productPromise["catch"](function () { productPromise = null; });
    }
    return productPromise;
  }
  // Warm the cache so ATC-time resolution beats the decision timeout. Retried
  // at intervals because the IG variant flag (window.CN_PAIR_POPUP) hydrates
  // async and may not be set at parse time.
  [0, 3000, 8000].forEach(function (delay) {
    setTimeout(function () { try { if (enabled()) fetchOpposite(); } catch (e) {} }, delay);
  });

  function fetchCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) {
        if (!r.ok) throw new Error("cn-pair-popup: cart fetch " + r.status);
        return r.json();
      });
  }

  // ── Matching ──
  function colorOptionKey(prod) {
    for (var i = 0; i < (prod.options || []).length; i++) {
      var o = prod.options[i];
      var name = typeof o === "string" ? o : o.name;
      if (name === "Color") return "option" + ((o.position || i + 1));
    }
    return "option2"; // both products today: option2 = Color
  }

  function availableInColor(prod, key, color) {
    return prod.variants.some(function (v) { return v[key] === color && v.available; });
  }

  function resolveMatch(addedItem, prod) {
    var key = colorOptionKey(prod);
    var srcColor = null;
    (addedItem.options_with_values || []).forEach(function (o) {
      if (o.name === "Color") srcColor = o.value;
    });

    var color = null, exact = false;
    if (srcColor && availableInColor(prod, key, srcColor)) { color = srcColor; exact = true; }
    else if (srcColor && COLOR_FALLBACK[srcColor] && availableInColor(prod, key, COLOR_FALLBACK[srcColor])) {
      color = COLOR_FALLBACK[srcColor];
    }
    if (!color && availableInColor(prod, key, "Black")) color = "Black";
    if (!color) {
      for (var i = 0; i < prod.variants.length; i++) {
        if (prod.variants[i].available) { color = prod.variants[i][key]; break; }
      }
    }
    if (!color) return null; // nothing in stock at all

    var sizeNeeded = cfg.direction === "wristband-to-sleeve";
    var sizes = [];
    if (sizeNeeded) {
      var seen = {};
      prod.variants.forEach(function (v) {
        if (v[key] !== color || seen[v.option1]) return;
        seen[v.option1] = true;
        sizes.push({ value: v.option1, available: v.available });
      });
    }

    var state = {
      prod: prod, colorKey: key, color: color, exact: exact,
      sizeNeeded: sizeNeeded, sizes: sizes, size: null, variant: null
    };
    if (sizeNeeded) {
      // Prefer SM-MD (one-tap default), else the first available size.
      var pick = null;
      sizes.forEach(function (s) {
        if (!s.available) return;
        if (s.value === "SM-MD") pick = s;
        else if (!pick) pick = s;
      });
      if (!pick) return null;
      state.size = pick.value;
    }
    state.variant = pickVariant(state);
    return state.variant ? state : null;
  }

  function pickVariant(state) {
    var match = null;
    state.prod.variants.forEach(function (v) {
      if (match || v[state.colorKey] !== state.color || !v.available) return;
      if (state.sizeNeeded && v.option1 !== state.size) return;
      match = v;
    });
    return match;
  }

  // ── Savings ──
  // Prefers the offer engine (cn-offer.js, IG-synced) when it's active; the
  // engine is currently held in reserve and not loaded on the live theme, so
  // the fallback mirrors the live Shopify automatic discounts ("20% OFF 2" …
  // "50% OFF 6", scoped to LEVER_HANDLES — see scripts/sync-offer-discounts.mjs).
  var FALLBACK_TIERS = [
    { qty: 2, discount: 20 },
    { qty: 3, discount: 30 },
    { qty: 4, discount: 40 },
    { qty: 6, discount: 50 }
  ];
  function discountForQty(q) {
    var offer = window.CN && window.CN.offer;
    if (offer && typeof offer.discountForQty === "function") return offer.discountForQty(q);
    var d = 0;
    FALLBACK_TIERS.forEach(function (t) { if (q >= t.qty) d = t.discount; });
    return d;
  }

  // Shopify allocates automatic discounts per UNIT and floors each unit's
  // discount to whole cents (root-caused 2026-07-13; same mirror as the
  // ATC-button fix in product-template.liquid). Promise what the cart will
  // actually show — never a Math.round of the total.
  function unitDiscount(unitPriceCents, pct) {
    return Math.floor(unitPriceCents * pct / 100);
  }

  function computeSavings(cart, variant) {
    var units = 0, lines = []; // cart is the POST-add cart: includes the just-added item
    (cart.items || []).forEach(function (i) {
      if (LEVER_HANDLES.indexOf(i.handle) > -1) {
        units += i.quantity;
        lines.push({ unit: i.original_price != null ? i.original_price : i.price, qty: i.quantity });
      }
    });
    if (!units) return null;
    // The suggestion is always a PAIR (2 units) of the opposite product.
    var curPct = discountForQty(units);
    var newPct = discountForQty(units + 2);
    if (!newPct) return null; // ladder off/empty — make no savings claim
    var pairSave = unitDiscount(variant.price, newPct) * 2;
    if (newPct > curPct) {
      var save = pairSave;
      lines.forEach(function (l) { save += unitDiscount(l.unit, newPct) * l.qty; });
      return { mode: "unlock", pct: newPct, fromPct: curPct, saveCents: save };
    }
    return {
      mode: "price", pct: newPct,
      saveCents: pairSave,
      payCents: variant.price * 2 - pairSave
    };
  }

  function money(cents) {
    return "$" + (cents / 100).toFixed(2);
  }

  // ── Analytics (dual dataLayer + gtag, never breaks UX) ──
  function track(name, extra) {
    try {
      var payload = Object.assign({
        event_category: "ecommerce",
        event_label: "cn_pair_popup",
        direction: cfg.direction
      }, extra || {});
      if (window.dataLayer && typeof window.dataLayer.push === "function") {
        window.dataLayer.push(Object.assign({ event: name }, payload));
      }
      if (typeof window.gtag === "function") window.gtag("event", name, payload);
    } catch (e) { /* swallow — analytics must never break UX */ }
  }

  // ── DOM ──
  function $(sel) { return document.querySelector(sel); }
  var root = null;
  // Portal the overlay to <body>: the snippet renders after team-order-popup,
  // whose markup swallows following siblings into .team_order--popupmain — an
  // off-screen containing block that breaks position:fixed. Body-append makes
  // the overlay immune to any ancestor transform/containment.
  (function portalToBody() {
    var el = $(".cn-pair-popup");
    if (el && el.parentElement !== document.body) document.body.appendChild(el);
  })();
  function els() {
    root = root || $(".cn-pair-popup");
    if (!root) return null;
    return {
      root: root,
      sheet: root.querySelector(".cn-pair-popup__sheet"),
      title: root.querySelector(".cn-pair-popup__title"),
      offerLine: root.querySelector(".cn-pair-popup__offer"),
      addedFig: root.querySelector(".cn-pair-popup__item--added"),
      addedWrap: root.querySelector(".cn-pair-popup__item--added .cn-pair-popup__imgwrap"),
      suggWrap: root.querySelector(".cn-pair-popup__item:not(.cn-pair-popup__item--added) .cn-pair-popup__imgwrap"),
      addedImg: root.querySelector(".cn-pair-popup__added-img"),
      addedNum: root.querySelector(".cn-pair-popup__added-num"),
      qtyBadge: root.querySelector(".cn-pair-popup__qty"),
      plus: root.querySelector(".cn-pair-popup__plus"),
      img: root.querySelector(".cn-pair-popup__img"),
      num: root.querySelector(".cn-pair-popup__sugg-num"),
      suggQty: root.querySelector(".cn-pair-popup__qty--sugg"),
      matchLine: root.querySelector(".cn-pair-popup__match"),
      suggCap: root.querySelector(".cn-pair-popup__cap--sugg"),
      suggRating: root.querySelector(".cn-pair-popup__rating"),
      suggRatingText: root.querySelector(".cn-pair-popup__rating-text"),
      swatchWrap: root.querySelector(".cn-pair-popup__swatches"),
      swatchRow: root.querySelector(".cn-pair-popup__swatch-row"),
      swatchToggle: root.querySelector(".cn-pair-popup__swatch-toggle"),
      sizeWrap: root.querySelector(".cn-pair-popup__sizes"),
      sizeRow: root.querySelector(".cn-pair-popup__size-row"),
      savePill: root.querySelector(".cn-pair-popup__save-pill"),
      cta: root.querySelector(".cn-pair-popup__cta"),
      decline: root.querySelector(".cn-pair-popup__decline"),
      close: root.querySelector(".cn-pair-popup__close")
    };
  }

  var active = null; // { state, savings, addedItem, continueFn, finished }

  // ── Live-mockup clone for the "In your cart" card ──
  // Mirrors the pinned bar's rebuildMock (custom-number-onimg.js): clone the
  // visible PDP mockup — real embroidery font, real number placement, live
  // colors — strip the slider chrome, and scale it into the card. Returns
  // false when no usable mockup is on the page (fallback = flat image+overlay).
  // The visible PDP mockup (mobile slider on phones, right media on desktop).
  function getLiveMock() {
    var nodes = document.querySelectorAll(".mobile-slider-main, .product-media-right-one");
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].offsetParent !== null && nodes[i].getBoundingClientRect().width > 0) return nodes[i];
    }
    return null;
  }

  // ── Sleeve mini-mockup ──
  // The sleeve card renders as a hand-built miniature of the PDP mockup: the
  // mock image plus the number at its EXACT PDP position (on the wrist) and
  // proportional size, with font-size set in px — crisp at any DPR, immune to
  // the slick slider's device-specific track offsets that made clones drift.
  // Constants measured from the live sleeve PDP (mock 207×396, number center
  // 48.7%/74.6%, font 43px = 20.8% of width, 2px stroke ≈ 1% of width); the
  // sleeve PDP re-measures live at render time, the wristband PDP uses these.
  // rot: the site-wide sleeve number rotation — 15deg on the PDP's .text-div.
  var SLEEVE_MOCK = { aspect: 1.913, fx: 0.487, fy: 0.746, fsRatio: 0.2077, strokeRatio: 0.0097, rot: 15 };

  function rotationOf(el) {
    try {
      var t = getComputedStyle(el).transform;
      if (!t || t === "none") return 0;
      var m = t.match(/matrix\(([-0-9.]+),\s*([-0-9.]+)/);
      return m ? Math.atan2(+m[2], +m[1]) * 180 / Math.PI : 0;
    } catch (e) { return 0; }
  }

  function sleeveGeom() {
    try {
      if (cfg.direction === "sleeve-to-wristband") {
        var live = getLiveMock();
        if (live) {
          var r = live.getBoundingClientRect();
          var td = live.querySelector(".text-div-m");
          if (r.width && r.height && td) {
            var tr = td.getBoundingClientRect();
            if (tr.height > 0) {
              var outer = live.querySelector(".text-div");
              return {
                aspect: r.height / r.width,
                fx: ((tr.left - r.left) + tr.width / 2) / r.width,
                fy: ((tr.top - r.top) + tr.height / 2) / r.height,
                fsRatio: (parseFloat(getComputedStyle(td).fontSize) / r.width) || SLEEVE_MOCK.fsRatio,
                strokeRatio: SLEEVE_MOCK.strokeRatio,
                rot: (outer ? rotationOf(outer) : 0) || rotationOf(td) || SLEEVE_MOCK.rot
              };
            }
          }
        }
      }
    } catch (e) {}
    return SLEEVE_MOCK;
  }

  // The mock image currently shown in the live slider (has the special prints
  // etc. that the flat variant image may lack). The slider holds every color's
  // slide side by side plus hidden loader imgs — pick the LOADED one whose box
  // actually overlaps the slider viewport.
  function liveSlideSrc() {
    try {
      var live = getLiveMock();
      if (!live) return "";
      var r = live.getBoundingClientRect();
      var imgs = live.querySelectorAll("img");
      for (var i = 0; i < imgs.length; i++) {
        var im = imgs[i];
        if (!im.naturalWidth) continue;
        var ir = im.getBoundingClientRect();
        if (ir.width < r.width * 0.5) continue;
        var mid = r.left + r.width / 2;
        if (ir.left <= mid && ir.right >= mid) return im.currentSrc || im.src || "";
      }
      return "";
    } catch (e) { return ""; }
  }

  // Ask the Shopify CDN for the image at the exact device-pixel size it will
  // render at. The CDN prefilters when it downscales; the browser does not,
  // so letting the browser shrink a large source aliases the band's fine
  // ribs into moiré — worse the smaller the target.
  function cdnSized(src, cssPx) {
    if (!src) return src;
    var px = Math.ceil((cssPx * (window.devicePixelRatio || 1)) / 10) * 10;
    var s = String(src).replace(/([?&])width=\d+/, "$1width=" + px);
    if (s === String(src)) s += (s.indexOf("?") > -1 ? "&" : "?") + "width=" + px;
    return s;
  }

  // Flags/icons are color-emoji glyphs: they carry their own colors, so fill
  // color and -webkit-text-stroke must NOT be applied — a stroke paints over
  // the color glyph and turns it into a blank silhouette (invisible on a
  // matching background). Render them in the site's emoji font instead.
  var EMOJI_RE = null;
  try { EMOJI_RE = new RegExp("[\\p{Extended_Pictographic}\\p{Regional_Indicator}]", "u"); } catch (err) {}
  function isEmojiVal(v) { return !!(EMOJI_RE && EMOJI_RE.test(String(v || ""))); }
  var EMOJI_FONT = "'Noto Color Emoji', sans-serif";

  // Band card image: the wristband photos are 400×800 with the band spanning
  // exactly y 25%→75%. Sized so that block sits centered with a few px of
  // padding — the full band, top and bottom edges included, always shows.
  function renderBandMini(wrap, imgSrc, altText) {
    var small = window.innerWidth < 375;
    var boxW = small ? 116 : 132, boxH = boxW;
    var pad = 4;
    // Zoomed out 5% (per Mike): the band read as slightly clipped top and
    // bottom at full size, so shrink it to buy vertical breathing room.
    var imgW = (boxW - pad * 2) / 1.05;
    var imgH = imgW * 2;
    var old = wrap.querySelector(".cn-pair-popup__mini");
    if (old) old.remove();
    var mini = document.createElement("div");
    mini.className = "cn-pair-popup__mini";
    mini.style.cssText = "position:absolute;inset:0;overflow:hidden;border-radius:11px;";
    var im = document.createElement("img");
    im.src = cdnSized(imgSrc, imgW);
    im.alt = altText || "";
    im.style.cssText = "position:absolute;left:" + ((boxW - imgW) / 2).toFixed(1) + "px;top:" + ((boxH / 2) - (imgH / 2)).toFixed(1) +
      "px;width:" + imgW.toFixed(1) + "px;height:" + imgH.toFixed(1) + "px;object-fit:cover;";
    mini.appendChild(im);
    wrap.style.width = boxW + "px";
    wrap.style.height = boxH + "px";
    wrap.appendChild(mini);
  }

  function renderSleeveMini(wrap, imgSrc, num, props, fallbackSrc) {
    var small = window.innerWidth < 375;
    var boxW = small ? 92 : 104, boxH = small ? 140 : 158;
    var g = sleeveGeom();
    var innerH = boxW * g.aspect;
    // Vertical cover-crop anchored so the number keeps its relative height
    // (the wrist) inside the window, exactly as on the PDP.
    var winHFrac = Math.min(1, (boxH / boxW) / g.aspect);
    // Bottom-anchored crop: the sleeve's lower end (wrist + cuff) always shows
    // fully; the trim comes off the top of the mockup instead.
    var winTopFrac = Math.max(0, 1 - winHFrac);

    var old = wrap.querySelector(".cn-pair-popup__mini");
    if (old) old.remove();
    var mini = document.createElement("div");
    mini.className = "cn-pair-popup__mini";
    mini.style.cssText = "position:absolute;inset:0;overflow:hidden;border-radius:11px;";
    var im = document.createElement("img");
    im.src = imgSrc;
    im.alt = "";
    if (fallbackSrc && fallbackSrc !== imgSrc) {
      im.onerror = function () { im.onerror = null; im.src = fallbackSrc; };
    }
    im.style.cssText = "position:absolute;left:0;top:" + (-winTopFrac * innerH).toFixed(1) +
      "px;width:" + boxW + "px;height:" + innerH.toFixed(1) + "px;object-fit:cover;";
    mini.appendChild(im);
    if (num) {
      var span = document.createElement("span");
      span.textContent = num;
      span.style.cssText =
        "position:absolute;transform:translate(-50%,-50%) rotate(" + (g.rot || 0).toFixed(1) + "deg);" +
        "line-height:1;pointer-events:none;" +
        // -1.5px: measured position reads a hair right of center at mini scale
        "left:" + (g.fx * boxW - 1.5).toFixed(1) + "px;" +
        "top:" + ((g.fy - winTopFrac) * innerH).toFixed(1) + "px;" +
        "font-size:" + (g.fsRatio * boxW).toFixed(1) + "px;";
      if (isEmojiVal(num)) {
        span.style.fontFamily = EMOJI_FONT;
      } else {
        span.style.webkitTextStroke = Math.max(0.8, g.strokeRatio * boxW).toFixed(1) + "px " +
          cssColor(props["Outline Color"]);
        span.style.color = cssColor(props["Fill Color"]);
        try {
          var anyTd = document.querySelector(".text-div-m");
          var ts = anyTd ? getComputedStyle(anyTd) : null;
          span.style.fontFamily = ts ? ts.fontFamily : "'Tomorrow', sans-serif";
          span.style.fontWeight = ts ? ts.fontWeight : "700";
          span.style.fontStyle = ts ? ts.fontStyle : "normal";
        } catch (e) {
          span.style.fontFamily = "'Tomorrow', sans-serif";
          span.style.fontWeight = "700";
        }
      }
      mini.appendChild(span);
    }
    wrap.style.width = boxW + "px";
    wrap.style.height = boxH + "px";
    wrap.appendChild(mini);
  }

  function buildAddedMockup(e) {
    try {
      var live = getLiveMock();
      if (!live) return false;
      var rect = live.getBoundingClientRect();
      if (!rect.width || !rect.height) return false;

      var isWristbandPdp = cfg.direction === "wristband-to-sleeve";
      var boxW = isWristbandPdp ? 132 : 106;
      var boxH = isWristbandPdp ? 132 : 158;
      var winW, winH, winLeft, winTop;
      if (isWristbandPdp) {
        // The band spans exactly y 25%→75% of the slide photo (measured by
        // pixel-scanning the band images, which map 1:1 onto the mock box).
        // Window that region zoomed in 20% (per Mike: band larger within the
        // card beats showing every edge) and centered on the embroidered
        // number so it sits dead-center in the card.
        winW = rect.width / 1.2;
        winH = rect.height * 0.45; // 0.54 / 1.2 — card size stays the same
        var bandC = { x: rect.width / 2, y: rect.height / 2 };
        // The mock holds one overlay per slide — pick the VISIBLE one (the
        // first in DOM order can be a hidden slide's 0-width copy).
        var bandTd = null;
        live.querySelectorAll(".text-div").forEach(function (el) {
          if (!bandTd && el.getBoundingClientRect().width > 0) bandTd = el;
        });
        if (bandTd) {
          var bandR = bandTd.getBoundingClientRect();
          bandC = {
            x: (bandR.left - rect.left) + bandR.width / 2,
            y: (bandR.top - rect.top) + bandR.height / 2
          };
        }
        winLeft = Math.max(0, Math.min(bandC.x - winW / 2, rect.width - winW));
        winTop = Math.max(0, Math.min(bandC.y - winH / 2, rect.height - winH));
      } else {
        // (Unused today — sleeve cards render via renderSleeveMini — kept as
        // the generic number-centered fallback.)
        winW = rect.width * 0.8;
        winH = winW * boxH / boxW;
        var tdC = { x: rect.width / 2, y: rect.height / 2 };
        var tdEl = live.querySelector(".text-div");
        if (tdEl) {
          var tdR = tdEl.getBoundingClientRect();
          if (tdR.height > 0) {
            tdC = { x: (tdR.left - rect.left) + tdR.width / 2, y: (tdR.top - rect.top) + tdR.height / 2 };
          }
        }
        if (winH > rect.height) { winH = rect.height; }
        winLeft = Math.max(0, Math.min(tdC.x - winW / 2, rect.width - winW));
        winTop = Math.max(0, Math.min(tdC.y - winH / 2, rect.height - winH));
      }
      var scale = boxW / winW;
      var wrapW = boxW, wrapH = Math.round(winH * scale);
      var offsetTop = winTop * scale;
      var offsetLeft = winLeft * scale;

      var clone = live.cloneNode(true);
      clone.removeAttribute("id");
      clone.querySelectorAll("[id]").forEach(function (el) { el.removeAttribute("id"); });
      clone.querySelectorAll(
        ".sleeve-loader, .sleeve-loader-img, .gallery_switcher, " +
        ".lifeStyle_slider_main, .lifeStyle_slider_thumbs, .main__image__right"
      ).forEach(function (el) { el.remove(); });

      // Wristband: collapse the cloned color slider to the single shown color
      // (a frozen slick track drifts when scaled — same fix as the pinned bar).
      if (isWristbandPdp) {
        var liveWrap = live.querySelector(".mobile-slider-wrapper");
        var cloneWrap = clone.querySelector(".mobile-slider-wrapper");
        if (liveWrap && cloneWrap) {
          var listLeft = liveWrap.getBoundingClientRect().left;
          var shownSrc = "";
          liveWrap.querySelectorAll(".mobile-slider-image img").forEach(function (im) {
            var r = im.getBoundingClientRect();
            if (r.width > 1 && Math.abs(r.left - listLeft) < 6) shownSrc = im.currentSrc || im.src;
          });
          if (!shownSrc) {
            var firstImg = liveWrap.querySelector(".mobile-slider-image img");
            if (firstImg) shownSrc = firstImg.currentSrc || firstImg.src;
          }
          if (shownSrc) {
            // Re-request at the final rendered size — the clone's CSS scale
            // otherwise GPU-shrinks the big slide photo into band-rib moiré.
            cloneWrap.innerHTML =
              '<img src="' + cdnSized(shownSrc, rect.width * scale) + '" alt="" ' +
              'style="display:block;width:100%;height:100%;object-fit:contain;">';
            cloneWrap.style.visibility = "visible";
            cloneWrap.style.opacity = "1";
          }
        }

        // Rebuild the embroidery overlay explicitly (the pinned bar's
        // rebuildMock technique): the slider collapse above can wipe the
        // visible slide's own overlay, leaving a hidden slide's copy at the
        // wrong size and position — numbers happened to roughly line up,
        // flags made it obvious. Drop every cloned overlay and re-create one
        // at the live overlay's measured position with its exact computed
        // type, so numbers AND emoji flags render just like the PDP.
        if (bandTd) {
          var liveInnerM = bandTd.querySelector(".text-div-m") || bandTd;
          var ics = getComputedStyle(liveInnerM);
          var ltr = bandTd.getBoundingClientRect();
          clone.querySelectorAll(".text-div").forEach(function (el) { el.remove(); });
          var ov = document.createElement("div");
          ov.textContent = liveInnerM.textContent;
          // Mike-tuned: the measured PDP size reads oversized at card scale —
          // numbers 10% smaller, flags 20% smaller.
          var ovFs = (parseFloat(ics.fontSize) || 0) *
            (isEmojiVal(liveInnerM.textContent) ? 0.8 : 0.9);
          ov.style.cssText =
            "position:absolute;line-height:1;pointer-events:none;white-space:nowrap;" +
            "left:" + ((ltr.left - rect.left) + ltr.width / 2).toFixed(1) + "px;" +
            "top:" + ((ltr.top - rect.top) + ltr.height / 2).toFixed(1) + "px;" +
            "transform:translate(-50%,-50%);" +
            "font-size:" + ovFs.toFixed(1) + "px;font-weight:" + ics.fontWeight + ";";
          ov.style.fontFamily = ics.fontFamily;
          ov.style.letterSpacing = ics.letterSpacing;
          ov.style.color = ics.color;
          if (ics.webkitTextStrokeWidth && ics.webkitTextStrokeWidth !== "0px") {
            ov.style.webkitTextStroke = ics.webkitTextStrokeWidth + " " + ics.webkitTextStrokeColor;
          }
          clone.appendChild(ov);
        }
      }

      // No font bump: the 20% window zoom already enlarges band and number
      // together, so the number stays proportionally identical to the PDP.

      clone.style.position = "absolute";
      clone.style.top = (-offsetTop) + "px";
      clone.style.left = (-offsetLeft) + "px";
      clone.style.margin = "0";
      clone.style.width = rect.width + "px";
      clone.style.height = rect.height + "px";
      clone.style.transformOrigin = "top left";
      clone.style.transform = "scale(" + scale + ")";

      e.addedWrap.style.width = wrapW + "px";
      e.addedWrap.style.height = wrapH + "px";
      var old = e.addedWrap.querySelector(".cn-pair-popup__mockclone");
      if (old) old.remove();
      var holder = document.createElement("div");
      holder.className = "cn-pair-popup__mockclone";
      // The wristband number-overlay CSS is scoped to `.wristbandmain .text-div`
      // — carry the class on the holder so the cloned overlay keeps its
      // position (same trick as the pinned bar's root).
      if (document.querySelector(".wristbandmain")) holder.classList.add("wristbandmain");
      holder.appendChild(clone);
      e.addedWrap.appendChild(holder);
      e.addedImg.style.display = "none";
      e.addedNum.style.display = "none";
      return true;
    } catch (err) {
      qlog("mockup clone failed, using flat image (" + err.message + ")");
      return false;
    }
  }

  function finish(how) {
    if (!active || active.finished) return;
    active.finished = true;
    var a = active;
    active = null;
    if (root) root.classList.remove("is-open");
    document.body.classList.remove("cn-pp-open");
    if (how) track("cn_pair_popup_decline", { method: how });
    // Defer past the current event's bubble: side-cart.js closes the drawer
    // on any document click outside it, so opening synchronously inside the
    // decline click would be undone when that same click reaches document.
    setTimeout(function () { a.continueFn(); }, 0);
  }

  // Tap-away / ESC: close the popup WITHOUT opening the side cart (per Mike:
  // only "×" and "No thanks" open it). The item is already in the cart; just
  // restore the ATC button that openSideCartNow would otherwise reset.
  function dismissQuiet(how) {
    if (!active || active.finished) return;
    active.finished = true;
    active = null;
    if (root) root.classList.remove("is-open");
    document.body.classList.remove("cn-pp-open");
    if (how) track("cn_pair_popup_decline", { method: how });
    var atcBtn = document.querySelector(".product-form__cart-submit");
    if (atcBtn) {
      atcBtn.classList.remove("cn-added");
      var orig = atcBtn.getAttribute("data-original-text");
      if (orig) atcBtn.textContent = orig;
    }
  }

  function setVariantVisuals(e) {
    var v = active.state.variant;
    var src = v && v.featured_image && v.featured_image.src;
    if (!src) {
      var imgs = active.state.prod.images || [];
      src = imgs.length ? imgs[0] : "";
    }
    if (src) {
      src = String(src).indexOf("?") > -1 ? src + "&width=480" : src + "?width=480";
      if (String(src).indexOf("//") === 0) src = "https:" + src;
    }
    var p = active.addedItem.properties || {};
    if (cfg.direction === "wristband-to-sleeve") {
      // Suggested sleeve renders as the mini-mockup (number on the wrist).
      e.img.style.display = "none";
      e.num.style.display = "none";
      if (src) renderSleeveMini(e.suggWrap, src, p["Embroidery Number"], p);
    } else if (src) {
      // Suggested band renders via the band window — full band, edges shown.
      e.img.style.display = "none";
      renderBandMini(e.suggWrap, src, (v && v.name) || cfg.oppositeName);
    }
    var noun = cfg.direction === "sleeve-to-wristband" ? "bands" : "sleeves";
    if (e.suggCap) e.suggCap.textContent = "Matching " + noun;
    if (e.suggRating) updateSuggRating(e, active.state.prod && active.state.prod.id);
    var lineNoun = cfg.direction === "sleeve-to-wristband" ? "wristbands" : "sleeves";
    var hasNum = !!p["Embroidery Number"];
    // "Same colors" only when the offered color NAME matches the added item's
    // exactly (per Mike); any COLOR_FALLBACK substitute — or a swatch change —
    // reads "complementary colors". Compared live so swatch taps stay truthful.
    var srcColor = null;
    (active.addedItem.options_with_values || []).forEach(function (o) {
      if (o.name === "Color") srcColor = o.value;
    });
    var colorsWord = srcColor === active.state.color ? "same colors" : "complementary colors";
    e.matchLine.textContent =
      (hasNum ? "Same number, " + colorsWord + " — "
              : colorsWord.charAt(0).toUpperCase() + colorsWord.slice(1) + " — ") +
      "a pair of " + active.state.color + " " + lineNoun + " to match.";
  }

  // ── Junip rating under the suggested-product caption ──
  // Live fetch (same public API the theme's Junip widget uses) so the count
  // stays current as reviews come in. Rating is decoration: any failure just
  // leaves the line hidden — it must never break the popup.
  var ratingCache = {};
  function updateSuggRating(e, prodId) {
    e.suggRating.style.display = "none";
    if (!prodId) return;
    if (ratingCache[prodId]) { paintSuggRating(e, ratingCache[prodId]); return; }
    var keyEl = document.querySelector(".junip-store-key");
    var storeKey = keyEl && keyEl.getAttribute("data-store-key");
    if (!storeKey) return;
    fetch("https://apid.juniphq.com/v2/products?remote_ids=" + prodId + "&page_size=1&v=" + storeKey, {
      headers: { "Junip-Store-Key": storeKey }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var p = j && j.data && j.data[0];
        if (!p || !p.rating_count) return;
        ratingCache[prodId] = { avg: Math.round(p.rating_average * 10) / 10, count: p.rating_count };
        paintSuggRating(e, ratingCache[prodId]);
      })
      .catch(function () {});
  }
  function paintSuggRating(e, r) {
    e.suggRatingText.textContent = r.avg;
    e.suggRating.style.display = "";
  }

  function renderSwatches(e) {
    if (active.state.exact) { e.swatchWrap.style.display = "none"; return; }
    e.swatchWrap.style.display = "block";
    e.swatchToggle.textContent = "Matched to " + active.state.color + " — change";
    e.swatchRow.style.display = "none";
    e.swatchRow.innerHTML = "";
    var key = active.state.colorKey, seen = {};
    active.state.prod.variants.forEach(function (v) {
      var c = v[key];
      if (seen[c] || !v.available) return;
      seen[c] = true;
      var b = document.createElement("button");
      b.type = "button";
      b.className = "cn-pair-popup__swatch" + (c === active.state.color ? " is-selected" : "");
      b.style.background = cssColor(c);
      b.setAttribute("aria-label", c);
      b.title = c;
      b.addEventListener("click", function () {
        active.state.color = c;
        active.state.variant = pickVariant(active.state);
        var sel = e.swatchRow.querySelector(".is-selected");
        if (sel) sel.classList.remove("is-selected");
        b.classList.add("is-selected");
        e.swatchToggle.textContent = "Matched to " + c + " — change";
        setVariantVisuals(e);
      });
      e.swatchRow.appendChild(b);
    });
  }

  function renderSizes(e) {
    if (!active.state.sizeNeeded) { e.sizeWrap.style.display = "none"; return; }
    e.sizeWrap.style.display = "block";
    e.sizeRow.innerHTML = "";
    active.state.sizes.forEach(function (s) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "cn-pair-popup__size" + (s.value === active.state.size ? " is-selected" : "");
      b.textContent = s.value;
      b.disabled = !s.available;
      b.addEventListener("click", function () {
        if (b.disabled) return;
        active.state.size = s.value;
        active.state.variant = pickVariant(active.state);
        var sel = e.sizeRow.querySelector(".is-selected");
        if (sel) sel.classList.remove("is-selected");
        b.classList.add("is-selected");
        setVariantVisuals(e);
      });
      e.sizeRow.appendChild(b);
    });
  }

  function render(addedItem, state, savings, continueFn) {
    var e = els();
    if (!e) { continueFn(); return; }
    active = { state: state, savings: savings, addedItem: addedItem, continueFn: continueFn, finished: false };

    var oppName = cfg.oppositeName || "Matching Item";
    e.title.textContent = "Added to Cart ✅";
    e.cta.textContent = "Add Matching " + oppName + " Pair";
    if (savings && savings.mode === "unlock") {
      // Already-discounted carts get the jump frame — the delta IS the offer
      // (a 2-sleeve cart double-skips 20%→40%). Zero-discount carts keep
      // "unlock": there's no "from" at 0%.
      e.offerLine.innerHTML = savings.fromPct > 0
        ? "Make it a matching set — jump from " + savings.fromPct + "% to <strong>" +
          savings.pct + "% OFF</strong> your whole order."
        : "Make it a matching set — unlock <strong>" + savings.pct +
          "% OFF</strong> your whole order.";
      e.savePill.textContent = "You save " + money(savings.saveCents);
      e.savePill.style.display = "";
    } else if (savings && savings.mode === "price") {
      e.offerLine.innerHTML = "You're at <strong>" + savings.pct +
        "% OFF</strong> — make it a matching set.";
      // "2 for 1" is only true at a 50% tier — gate it so the claim stays
      // honest if the ladder ever changes. No price in the 50% pill: Shopify's
      // per-unit floor makes the pair $36.00 vs the $35.99 single, and a
      // 1¢-over figure printed next to "2 for 1" undercuts the claim.
      e.savePill.textContent = savings.pct === 50 ? "2 for 1" : "Pair just " + money(savings.payCents);
      e.savePill.style.display = "";
    } else {
      // Offer data unavailable — never show wrong math, still show the match.
      e.offerLine.textContent = "Make it a matching set.";
      e.savePill.style.display = "none";
    }

    // "The set" viz: what's just been added on the left, the suggestion on the
    // right — the shopper sees the full matching set next to the discount.
    // Preferred source for the added card: a scaled clone of the live PDP
    // mockup (real embroidery font + placement). Fallback: flat line-item
    // image with the text overlay.
    var p0 = addedItem.properties || {};
    var stale = e.addedWrap.querySelector(".cn-pair-popup__mockclone");
    if (stale) stale.remove();
    var staleMini = e.addedWrap.querySelector(".cn-pair-popup__mini");
    if (staleMini) staleMini.remove();
    e.addedWrap.style.width = "";
    e.addedWrap.style.height = "";
    e.addedImg.style.display = "";
    var addedSrc = addedItem.image || (addedItem.featured_image && addedItem.featured_image.url) || "";
    if (addedSrc) {
      addedSrc = String(addedSrc).indexOf("?") > -1 ? addedSrc + "&width=480" : addedSrc + "?width=480";
      if (String(addedSrc).indexOf("//") === 0) addedSrc = "https:" + addedSrc;
      e.addedImg.src = addedSrc;
      e.addedImg.alt = addedItem.product_title || "";
    }
    // Added card: wristband PDP clones the live band mockup; sleeve PDP builds
    // the deterministic mini-mockup (crisp text, exact PDP wrist placement —
    // the clone drifted per-device and blurred on retina).
    var haveMockClone = false, haveAddedMini = false;
    if (cfg.direction === "wristband-to-sleeve") {
      haveMockClone = buildAddedMockup(e);
    } else {
      var miniSrc = liveSlideSrc() || addedSrc;
      if (miniSrc) {
        renderSleeveMini(e.addedWrap, miniSrc, p0["Embroidery Number"], p0, addedSrc);
        haveAddedMini = true;
        e.addedImg.style.display = "none";
      }
    }
    if (haveMockClone || haveAddedMini || addedSrc) {
      e.addedFig.style.display = "";
      e.plus.style.display = "";
    } else {
      // Neither a mockup nor an image — fall back to suggestion-only.
      e.addedFig.style.display = "none";
      e.plus.style.display = "none";
    }
    // /cart/add.js reports the line's TOTAL quantity after merging with what
    // was already in the cart — not the amount just added. Read the amount
    // actually submitted from the PDP form (same lookup the templates use);
    // blank badge for a single unit.
    var addedQty = 1;
    var qtyInput = document.getElementById("Quantity-product-template") ||
      document.querySelector('form.product-form input[name="quantity"]');
    if (qtyInput) {
      var qv = parseInt(qtyInput.value, 10);
      if (qv > 0) addedQty = qv;
    }
    if (addedQty > 1) {
      e.qtyBadge.textContent = "×" + addedQty;
      e.qtyBadge.style.display = "";
    } else {
      e.qtyBadge.style.display = "none";
    }
    if (e.suggQty) e.suggQty.textContent = "×2"; // always a pair

    // Number preview overlays (skip when no embroidery number). The added card
    // skips its overlay when the live-mockup clone is in use — the clone
    // already carries the number in the real embroidery font/placement.
    var p = addedItem.properties || {};
    var num = p["Embroidery Number"];
    // Copy the real embroidery type from the VISIBLE mockup's own overlay —
    // family, weight, style, spacing — so the popup numbers match the other
    // text mockups on the site exactly.
    var mockType = null;
    try {
      var liveMockEl = getLiveMock();
      // The styled glyph is the INNER .text-div-m ("Tomorrow" 700, 2px stroke);
      // the outer .text-div is just a Poppins-styled container.
      var liveTd = liveMockEl &&
        (liveMockEl.querySelector(".text-div-m") || liveMockEl.querySelector(".text-div"));
      if (liveTd) {
        var tds = getComputedStyle(liveTd);
        mockType = {
          fontFamily: tds.fontFamily,
          fontWeight: tds.fontWeight,
          fontStyle: tds.fontStyle,
          letterSpacing: tds.letterSpacing,
          strokeWidth: tds.webkitTextStrokeWidth
        };
      }
    } catch (err) {}
    // Overlay numbers: only the wristband cards use a centered text overlay
    // (the band face is central); sleeve cards carry their number inside the
    // mini-mockup at the exact PDP wrist position. Added-card overlay is a
    // fallback only, for when both mockup paths fail.
    var wristbandPx = 62, sleevePx = 34;
    function styleOverlay(numEl, px) {
      if (!num) { numEl.style.display = "none"; return; }
      numEl.textContent = num;
      if (isEmojiVal(num)) {
        numEl.style.color = "";
        numEl.style.webkitTextStroke = "0";
        numEl.style.fontFamily = EMOJI_FONT;
        numEl.style.fontSize = px + "px";
        numEl.style.display = "block";
        return;
      }
      numEl.style.color = cssColor(p["Fill Color"]);
      numEl.style.webkitTextStrokeColor = cssColor(p["Outline Color"]);
      numEl.style.fontSize = px + "px";
      if (mockType) {
        numEl.style.fontFamily = mockType.fontFamily;
        numEl.style.fontWeight = mockType.fontWeight;
        numEl.style.fontStyle = mockType.fontStyle;
        numEl.style.letterSpacing = mockType.letterSpacing;
        if (mockType.strokeWidth && mockType.strokeWidth !== "0px") {
          numEl.style.webkitTextStrokeWidth = mockType.strokeWidth;
        }
      }
      numEl.style.display = "block";
    }
    if (cfg.direction === "sleeve-to-wristband") {
      styleOverlay(e.num, wristbandPx); // suggested band
    } else {
      e.num.style.display = "none"; // suggested sleeve = mini-mockup
    }
    if (haveMockClone || haveAddedMini) {
      e.addedNum.style.display = "none";
    } else {
      styleOverlay(e.addedNum, cfg.direction === "wristband-to-sleeve" ? wristbandPx : sleevePx);
    }

    setVariantVisuals(e);
    renderSwatches(e);
    renderSizes(e);

    e.cta.disabled = false;
    e.cta.classList.remove("is-loading");

    try { sessionStorage.setItem(SHOWN_KEY, "1"); } catch (err) {}
    // Sizing chart starts collapsed on every open; match line restored
    var szChart = root.querySelector(".cn-pair-popup__sizechart");
    var szTog = root.querySelector(".cn-pair-popup__sizechart-toggle");
    if (szChart) szChart.style.display = "none";
    if (szTog) szTog.textContent = "Sizing Chart ▾";
    e.matchLine.style.display = "";
    root.classList.add("is-open");
    document.body.classList.add("cn-pp-open");
    track("cn_pair_popup_shown", {
      new_tier_pct: savings ? savings.pct : null,
      savings: savings ? +(savings.saveCents / 100).toFixed(2) : null,
      color_fallback_used: !state.exact
    });
  }

  function accept() {
    if (!active || active.finished) return;
    var e = els();
    var v = active.state.variant;
    if (!v) { finish("no_variant"); return; }
    e.cta.disabled = true;
    e.cta.classList.add("is-loading");
    e.cta.textContent = "Adding…";

    var p = active.addedItem.properties || {};
    var fd = new FormData();
    fd.append("id", v.id);
    fd.append("quantity", 2); // the suggestion is a matching PAIR
    if (p["Embroidery Number"]) fd.append("properties[Embroidery Number]", p["Embroidery Number"]);
    if (p["Fill Color"]) fd.append("properties[Fill Color]", p["Fill Color"]);
    if (p["Outline Color"]) fd.append("properties[Outline Color]", p["Outline Color"]);
    if (p["Estimated Delivery"]) fd.append("properties[Estimated Delivery]", p["Estimated Delivery"]);

    var s = active.savings;
    fetch("/cart/add.js", {
      method: "POST",
      body: fd,
      headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/json" }
    })
      .then(function (r) { if (!r.ok) throw new Error("add failed " + r.status); return r.json(); })
      .then(function () {
        track("cn_pair_popup_accept", {
          variant_id: v.id,
          new_tier_pct: s ? s.pct : null,
          savings: s ? +(s.saveCents / 100).toFixed(2) : null,
          size: active.state.sizeNeeded ? active.state.size : null,
          color_fallback_used: !active.state.exact
        });
        if (!active.finished) {
          active.finished = true;
          var a = active; active = null;
          root.classList.remove("is-open");
          document.body.classList.remove("cn-pp-open");
          // An accept re-arms the popup for this session: buyers adding sets
          // for multiple kids should get the offer for each new number.
          // Decliners stay suppressed — the shown marker only clears here.
          try { sessionStorage.removeItem(SHOWN_KEY); } catch (err) {}
          a.continueFn(); // drawer's own /cart.js refetch shows both items
        }
      })
      ["catch"](function (err) {
        console.error("cn-pair-popup: suggested add failed", err);
        finish("accept_error"); // item wasn't added, but never block the cart
      });
  }

  // Static listeners (popup markup exists from page load, hidden)
  document.addEventListener("click", function (ev) {
    if (!active || active.finished) return;
    if (ev.target.closest(".cn-pair-popup__cta")) { ev.preventDefault(); accept(); return; }
    if (ev.target.closest(".cn-pair-popup__decline")) { ev.preventDefault(); finish("decline_link"); return; }
    if (ev.target.closest(".cn-pair-popup__close")) { ev.preventDefault(); finish("close_button"); return; }
    if (ev.target.closest(".cn-pair-popup__swatch-toggle")) {
      ev.preventDefault();
      var row = els().swatchRow;
      row.style.display = row.style.display === "none" ? "flex" : "none";
      return;
    }
    if (ev.target.closest(".cn-pair-popup__sizechart-toggle")) {
      ev.preventDefault();
      var tog = ev.target.closest(".cn-pair-popup__sizechart-toggle");
      var chart = root ? root.querySelector(".cn-pair-popup__sizechart") : null;
      if (chart) {
        var opening = chart.style.display === "none";
        chart.style.display = opening ? "block" : "none";
        tog.textContent = opening ? "Sizing Chart ▴" : "Sizing Chart ▾";
        // The match line makes way for the chart (per Mike) and returns when
        // the chart closes.
        var ml = root.querySelector(".cn-pair-popup__match");
        if (ml) ml.style.display = opening ? "none" : "";
        // If the taller content hits the sheet's max-height cap, the sheet
        // scrolls internally — pin it to the bottom so everything from the
        // size label down holds position and the content ABOVE slides up.
        var sheetEl = root.querySelector(".cn-pair-popup__sheet");
        if (opening && sheetEl) sheetEl.scrollTop = sheetEl.scrollHeight;
      }
      return;
    }
    // Overlay tap = anywhere on the fixed backdrop outside the sheet.
    // Quiet dismiss: the side cart only opens via "×" or "No thanks".
    if (ev.target.classList && ev.target.classList.contains("cn-pair-popup")) {
      dismissQuiet("overlay_tap");
    }
  });
  document.addEventListener("keydown", function (ev) {
    if (active && !active.finished && ev.key === "Escape") dismissQuiet("escape_key");
  });

  // ── Public API ──
  window.CNPairPopup = {
    maybeShow: function (addedItem, continueFn) {
      try {
        if (typeof continueFn !== "function") return;
        function skip(reason) { qlog("skipped: " + reason); continueFn(); }
        if (!enabled()) {
          return skip("disabled (theme setting off, no IG flag, no ?cn-pair-popup=1)");
        }
        if (!addedItem || addedItem.handle !== cfg.ownHandle) {
          return skip("added item is not this PDP's product");
        }
        var shown = null;
        try { shown = sessionStorage.getItem(SHOWN_KEY); } catch (e) {}
        if (shown) {
          if (qaMode()) { qlog("shown-once suppression bypassed (QA mode)"); }
          else return skip("already shown this session (reset with ?cn-pair-popup=1)");
        }

        // Race all async decisions against the timeout: a slow network opens
        // the cart normally, and the exactly-once guard on continueFn plus the
        // timedOut flag guarantee the popup never appears afterwards.
        var timedOut = false;
        var timer = setTimeout(function () {
          timedOut = true;
          qlog("skipped: cart/product data didn't arrive within " + DECIDE_MS + "ms — opening cart");
          continueFn();
        }, DECIDE_MS);

        Promise.all([fetchCart(), fetchOpposite()])
          .then(function (res) {
            clearTimeout(timer);
            if (timedOut || continueFn._done) return;
            var cart = res[0], prod = res[1];
            var state = resolveMatch(addedItem, prod);
            if (!state) { return skip("no available matching variant"); }
            // Suppress only a true duplicate: the cart already holds the
            // opposite product in THIS number and THIS color (the color the
            // popup would offer, fallback included). #23 Ice Blue bands must
            // not block a #7 offer (multi-kid orders) or a #23 Red offer
            // (two sets for the same kid in different colors).
            var addedNum = (((addedItem.properties || {})["Embroidery Number"] || "") + "").trim().toUpperCase();
            var hasDuplicate = (cart.items || []).some(function (i) {
              if (i.handle !== cfg.oppositeHandle) return false;
              var n = (((i.properties || {})["Embroidery Number"] || "") + "").trim().toUpperCase();
              if (n !== addedNum) return false;
              var c = null;
              (i.options_with_values || []).forEach(function (o) { if (o.name === "Color") c = o.value; });
              return c === state.color;
            });
            if (hasDuplicate) {
              if (qaMode()) { qlog("opposite-in-cart suppression bypassed (QA mode)"); }
              else return skip("matching set for this number & color already in cart");
            }
            qlog("showing popup (" + cfg.direction + ")");
            render(addedItem, state, computeSavings(cart, state.variant), continueFn);
          })
          ["catch"](function (err) {
            clearTimeout(timer);
            console.error("cn-pair-popup:", err);
            if (!timedOut) continueFn();
          });
      } catch (e) {
        console.error("cn-pair-popup:", e);
        continueFn();
      }
    }
  };
})();
